
import { useTranslation } from 'react-i18next';
import { IconButton, Tooltip } from '@mui/material';
import { ReactComponent as InfoOutlineIcon } from 'assets/images/svg/info_outline.svg';


const PasswordInfo = ({ length, nbOldPassword }) => {
    const { t } = useTranslation();

    return <Tooltip title={<>
    <>{t("password.info1")}<br /></>
    <>* {t("password.info2")}<br /></>
    <>* {t("password.info3_1")} {length} {t("password.info3_2")}<br /></>
    <>* {t("password.info4")}<br /></>
    <>{nbOldPassword !== "0" ? `* ${t("password.info5_1")} ${nbOldPassword} ${t("password.info5_2")}` : `* ${t("password.info5_3")}` }</></>}>
    <IconButton sx={{ m: 0, p: 0 }} edge="end">
        <InfoOutlineIcon />
    </IconButton>

</Tooltip >;
};


export default PasswordInfo;